import { useSecurityEvents } from "../../hooks/useSecurity";

const LABEL = {
  login_ok: "✅ Entrada",
  login_bad_password: "❌ Contraseña incorrecta",
  totp_bad: "❌ Código de 2 pasos incorrecto",
  totp_enabled: "🔐 Se activaron los 2 pasos",
  totp_disabled: "⚠️ Se desactivaron los 2 pasos",
  pin_set: "🔢 PIN configurado",
  code_requested: "📨 Se pidió un código",
  fallback_ok: "🛟 Recuperación (código + PIN)",
  fallback_bad: "❌ Recuperación fallida",
  recovery_code_used: "🛟 Código de recuperación usado",
  recovery_code_bad: "❌ Código de recuperación malo",
  codes_regenerated: "🔁 Códigos de recuperación nuevos",
  password_changed: "🔑 Contraseña cambiada",
  password_forgot_ok: "🔑 Contraseña recuperada",
  settings_changed: "⚙️ Ajustes cambiados",
  sessions_revoked: "🚪 Sesiones cerradas",
  device_removed: "🖥️ Dispositivo quitado",
  emergency_reset: "🆘 Reset de emergencia",
};

// Lo último que pasó con la cuenta: entradas, fallos y cambios (con IP y navegador). Nunca contraseñas ni códigos.
export function ActivitySection() {
  const { data: events, isLoading, isError } = useSecurityEvents(true);
  return (
    <div data-testid="activity-section" className="space-y-2">
      {isLoading && <p className="text-xs text-muted-foreground">Cargando…</p>}
      {isError && <p className="text-xs text-amber-500">No se pudo leer la actividad.</p>}
      {events && events.length === 0 && <p data-testid="activity-empty" className="text-xs text-muted-foreground">Todavía no hay actividad.</p>}
      <ul className="space-y-1">
        {(events || []).map((e, i) => (
          <li key={i} data-testid="activity-item" className="flex items-start justify-between gap-2 text-xs">
            <span>{LABEL[e.kind] || e.kind}{e.detail ? <span className="text-muted-foreground"> · {e.detail}</span> : null}</span>
            <span className="shrink-0 text-muted-foreground">{e.at} · {e.device} · {e.ip}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
